import Download from "@mui/icons-material/Download";
import { Button, CircularProgress } from "@mui/material";
import { useDownloadFiles } from "hooks/useDownloadFiles";

/**
 * The download action under an export notification's body.
 *
 * A finished export has no page to open — its files are the whole record — and
 * the body cannot carry a plain link to them, because the signed URL it would
 * have to embed expires long before the notification does. So the keys ride on
 * the subject and are signed here, on the click.
 *
 * Renders nothing for a subject that produced no files, which is every subject
 * but a finished export.
 */
export function NotificationDownloadButton({
  subject,
}: {
  subject: { downloadKeys: string[] } | null;
}) {
  const { download, busy } = useDownloadFiles();
  const downloadKeys = subject?.downloadKeys ?? [];

  if (downloadKeys.length === 0) {
    return null;
  }

  const label = downloadKeys.length > 1 ? `Download ${downloadKeys.length} files` : "Download";

  return (
    <Button
      variant="outlined"
      startIcon={busy ? <CircularProgress size={20} /> : <Download />}
      onClick={() => download(downloadKeys)}
      disabled={busy}
      sx={{ mt: 2 }}
    >
      {busy ? "Downloading…" : label}
    </Button>
  );
}
